import NewsletterSevenContainers from "./containers/NewsletterSevenContainers";
export default NewsletterSevenContainers;
